import { gql } from '@apollo/client';

import {
  BAGGING_DISPATCH_RECORD_FIELDS,
  DELIVERY_TICKET_MEALS_FIELDS,
  DRIVER_DISPATCH_FIELDS,
  EXPORT_FILE_RESPONSE_FIELDS,
  FOOD_PORTIONING_RECORD_FIELDS,
  LIST_BAGGING_DISPATCH_BY_RANGE_RESPONSE_FIELDS,
  LIST_CHEFS_FIELDS,
  LIST_COMPLAINTS_RESPONSE_FIELDS,
  LIST_COMPONENT_BATCHES_RESPONSE_FIELDS,
  LIST_DAILY_DISPATCH_LEFTOVER_STATS_RESPONSE_FIELDS,
  LIST_DELIVERIES_RESPONSE_FIELDS,
  LIST_DELIVERY_TICKETS_RESPONSE_FIELDS,
  LIST_FOODS_BY_FILTERS_RESPONSE_FIELDS,
  LIST_FOODS_RESPONSE_FIELDS,
  LIST_FOOD_COMPONENTS_FOR_PRINT_RESPONSE_FIELDS,
  LIST_FOOD_COMPONENTS_RESPONSE_FIELDS,
  LIST_FOOD_COMPONENT_BY_RANGE_RESPONSE_FIELDS,
  LIST_FOOD_COMPONENT_LEFTOVER_STATS_RESPONSE_FIELDS,
  LIST_FOOD_COMPONENT_YIELD_BATCHES_RESPONSE_FIELDS,
  LIST_GIFTS_RESPONSE_FIELDS,
  LIST_INGREDIENTS_RESPONSE_FIELDS,
  LIST_KITCHENS_RESPONSE_FIELDS,
  LIST_MEAL_TIMESTAMPS_RESPONSE_FIELDS,
  LIST_PRODUCTIVITY_METRICS_RESPONSE_FIELDS,
  LIST_QUALITY_METRICS_RESPONSE_FIELDS,
  LIST_STAFF_TRACKING_RESPONSE_FIELDS,
  NOTIFICATION_STATS_FIELDS,
  PROD_CONTROL_MEAL_FIELDS,
  SHOPPING_MENU_FIELDS,
  SINGLE_FOOD_COMPONENT_FIELDS
} from './fragments';

export const EXPORT_BAGGING_SESSION_QUERY = gql`
  ${EXPORT_FILE_RESPONSE_FIELDS}
  query ExportBaggingSession(
    $kitchen: Kitchen
    $startDate: String
    $endDate: String
    $shift: String
    $actions: [String]
    $fileType: String
    $city: [String]
    $mealType: [String]
    $onlySandwich: Boolean
  ) {
    exportBaggingSession(
      kitchen: $kitchen
      startDate: $startDate
      endDate: $endDate
      shift: $shift
      actions: $actions
      fileType: $fileType
      city: $city
      mealType: $mealType
      onlySandwich: $onlySandwich
    ) {
      ...ExportFileResponseFields
    }
  }
`;

export const GET_FOOD_PORTIONING_RECORD_QUERY = gql`
  ${FOOD_PORTIONING_RECORD_FIELDS}
  query GetFoodPortioningRecord($kitchen: Kitchen!, $day: String!, $shift: Session!, $variant: FoodPortioningRecordVariant!) {
    getFoodPortioningRecord(kitchen: $kitchen, day: $day, shift: $shift, variant: $variant) {
      ...FoodPortioningRecordFields
    }
  }
`;

export const EXPORT_FOOD_PORTIONING_RECORD_QUERY = gql`
  query ExportFoodPortioningRecord($kitchen: Kitchen!, $day: String!, $shift: Session!, $variant: FoodPortioningRecordVariant!) {
    exportFoodPortioningRecord(kitchen: $kitchen, day: $day, shift: $shift, variant: $variant)
  }
`;

export const GET_BAGGING_DISPATCH_RECORD_QUERY = gql`
  ${BAGGING_DISPATCH_RECORD_FIELDS}
  query GetBaggingDispatchRecord($kitchen: Kitchen!, $day: String!, $shift: Session!) {
    getBaggingDispatchRecord(kitchen: $kitchen, day: $day, shift: $shift) {
      ...BaggingDispatchRecordFields
    }
  }
`;

export const EXPORT_BAGGING_DISPATCH_RECORD_QUERY = gql`
  query ExportBaggingDispatchRecord($kitchen: Kitchen!, $day: String!, $shift: Session!) {
    exportBaggingDispatchRecord(kitchen: $kitchen, day: $day, shift: $shift)
  }
`;

export const GET_FOOD_COMPONENT_QUERY = gql`
  ${SINGLE_FOOD_COMPONENT_FIELDS}
  query GetFoodComponent($id: String) {
    getFoodComponent(id: $id) {
      ...SingleFoodComponentFields
    }
  }
`;

export const GET_FOOD_COMPONENT_V2_QUERY = gql`
  ${SINGLE_FOOD_COMPONENT_FIELDS}
  query GetFoodComponentV2($id: String) {
    getFoodComponentV2(id: $id) {
      ...SingleFoodComponentFields
    }
  }
`;

export const GET_NOTIFICATION_STATS_QUERY = gql`
  ${NOTIFICATION_STATS_FIELDS}
  query GetNotificationStats($date: String, $kitchen: Kitchen) {
    getNotificationStats(date: $date, kitchen: $kitchen) {
      ...NotificationStatsFields
    }
  }
`;

export const GET_SHOPPING_MENU_QUERY = gql`
  ${SHOPPING_MENU_FIELDS}
  query GetShoppingMenu($id: String, $kitchen: Kitchen) {
    getShoppingMenu(id: $id, kitchen: $kitchen) {
      ...ShoppingMenuFields
    }
  }
`;

export const LIST_BAGGING_DISPATCH_BY_RANGE_QUERY = gql`
  ${LIST_BAGGING_DISPATCH_BY_RANGE_RESPONSE_FIELDS}
  query ListBaggingDispatchByRange($kitchen: Kitchen, $startDate: String, $endDate: String, $limit: Int, $next: String) {
    listBaggingDispatchByRange(kitchen: $kitchen, startDate: $startDate, endDate: $endDate, limit: $limit, next: $next) {
      ...ListBaggingDispatchByRangeResponseFields
    }
  }
`;

export const LIST_CHEFS_QUERY = gql`
  ${LIST_CHEFS_FIELDS}
  query ListChefs($kitchen: Kitchen) {
    listChefs(kitchen: $kitchen) {
      ...ListChefsFields
    }
  }
`;

export const LIST_COMPLAINTS_QUERY = gql`
  ${LIST_COMPLAINTS_RESPONSE_FIELDS}
  query ListComplaints($query: ListComplaintInput) {
    listComplaints(query: $query) {
      ...ListComplaintsResponseFields
    }
  }
`;

export const LIST_COMPONENT_BATCHES_QUERY = gql`
  ${LIST_COMPONENT_BATCHES_RESPONSE_FIELDS}
  query ListComponentBatches($kitchen: Kitchen, $date: RangeInput, $shift: String) {
    listComponentBatches(kitchen: $kitchen, date: $date, shift: $shift) {
      ...ListComponentBatchesResponseFields
    }
  }
`;

export const LIST_DAILY_DISPATCH_LEFTOVER_STATS_QUERY = gql`
  ${LIST_DAILY_DISPATCH_LEFTOVER_STATS_RESPONSE_FIELDS}
  query ListDailyDispatchLeftoverStats($kitchen: Kitchen, $startDate: String, $endDate: String) {
    listDailyDispatchLeftoverStats(kitchen: $kitchen, startDate: $startDate, endDate: $endDate) {
      ...ListDailyDispatchLeftoverStatsResponseFields
    }
  }
`;

export const LIST_DELIVERIES_QUERY = gql`
  ${LIST_DELIVERIES_RESPONSE_FIELDS}
  query ListDeliveries($query: ListDeliveriesInput) {
    listDeliveries(query: $query) {
      ...ListDeliveriesResponseFields
    }
  }
`;

export const LIST_DELIVERY_TICKET_MEALS_QUERY = gql`
  ${DELIVERY_TICKET_MEALS_FIELDS}
  query ListDeliveryTicketMeals($deliveryIds: [String!]!) {
    listDeliveryTicketMeals(deliveryIds: $deliveryIds) {
      ...DeliveryTicketMealsFields
    }
  }
`;

export const LIST_DELIVERY_TICKETS_QUERY = gql`
  ${LIST_DELIVERY_TICKETS_RESPONSE_FIELDS}
  query ListDeliveryTickets($query: listDeliveryTicketsInput) {
    listDeliveryTickets(query: $query) {
      ...ListDeliveryTicketsResponseFields
    }
  }
`;

export const LIST_DRIVER_DISPATCHES_QUERY = gql`
  ${DRIVER_DISPATCH_FIELDS}
  query ListDriverDispatches($kitchen: Kitchen, $date: String, $deliveryTime: String) {
    listDriverDispatches(kitchen: $kitchen, date: $date, deliveryTime: $deliveryTime) {
      ...DriverDispatchFields
    }
  }
`;

// Bag counts read every order on the routes, so they stay out of the shared fragment.
export const LIST_DRIVER_DISPATCHES_WITH_BAGS_QUERY = gql`
  ${DRIVER_DISPATCH_FIELDS}
  query ListDriverDispatchesWithBags($kitchen: Kitchen, $date: String, $deliveryTime: String) {
    listDriverDispatches(kitchen: $kitchen, date: $date, deliveryTime: $deliveryTime) {
      ...DriverDispatchFields
      chilledBags
      frozenBags
      totalBags
    }
  }
`;

export const LIST_FOOD_COMPONENT_BY_RANGE_QUERY = gql`
  ${LIST_FOOD_COMPONENT_BY_RANGE_RESPONSE_FIELDS}
  query ListFoodComponentByRange(
    $kitchen: Kitchen
    $startDate: String
    $endDate: String
    $limit: Int
    $next: String
    $filters: ListFoodComponentByRangeFilters
  ) {
    listFoodComponentByRange(
      kitchen: $kitchen
      startDate: $startDate
      endDate: $endDate
      limit: $limit
      next: $next
      filters: $filters
    ) {
      ...ListFoodComponentByRangeResponseFields
    }
  }
`;

export const LIST_FOOD_COMPONENT_LEFTOVER_STATS_QUERY = gql`
  ${LIST_FOOD_COMPONENT_LEFTOVER_STATS_RESPONSE_FIELDS}
  query ListFoodComponentLeftoverStats($kitchen: Kitchen, $startDate: String, $endDate: String) {
    listFoodComponentLeftoverStats(kitchen: $kitchen, startDate: $startDate, endDate: $endDate) {
      ...ListFoodComponentLeftoverStatsResponseFields
    }
  }
`;

export const LIST_FOOD_COMPONENT_YIELD_BATCHES_QUERY = gql`
  ${LIST_FOOD_COMPONENT_YIELD_BATCHES_RESPONSE_FIELDS}
  query ListFoodComponentYieldBatches($filters: ListFoodComponentYieldBatchesFilters!, $next: String) {
    listFoodComponentYieldBatches(filters: $filters, next: $next) {
      ...ListFoodComponentYieldBatchesResponseFields
    }
  }
`;

export const LIST_FOOD_COMPONENTS_BY_NAME_QUERY = gql`
  ${LIST_FOOD_COMPONENTS_RESPONSE_FIELDS}
  query ListFoodComponentsByName(
    $kitchen: Kitchen
    $brand: String
    $name: String
    $ingredientId: String
    $limit: Int
    $next: String
  ) {
    listFoodComponentsByName(
      kitchen: $kitchen
      brand: $brand
      name: $name
      ingredientId: $ingredientId
      limit: $limit
      next: $next
    ) {
      ...ListFoodComponentsResponseFields
    }
  }
`;

export const LIST_FOOD_COMPONENTS_FOR_PRINT_QUERY = gql`
  ${LIST_FOOD_COMPONENTS_FOR_PRINT_RESPONSE_FIELDS}
  query ListFoodComponentsForPrint($componentIds: [String!]!, $kitchen: Kitchen!, $date: String!) {
    listFoodComponentsForPrint(componentIds: $componentIds, kitchen: $kitchen, date: $date) {
      ...ListFoodComponentsForPrintResponseFields
    }
  }
`;

export const LIST_FOOD_COMPONENTS_FOR_PRINT_V2_QUERY = gql`
  ${LIST_FOOD_COMPONENTS_FOR_PRINT_RESPONSE_FIELDS}
  query ListFoodComponentsForPrintV2($componentIds: [String!]!, $kitchen: Kitchen!, $date: String!) {
    listFoodComponentsForPrintV2(componentIds: $componentIds, kitchen: $kitchen, date: $date) {
      ...ListFoodComponentsForPrintResponseFields
    }
  }
`;

export const LIST_FOOD_COMPONENTS_QUERY = gql`
  ${LIST_FOOD_COMPONENTS_RESPONSE_FIELDS}
  query ListFoodComponents(
    $kitchen: Kitchen
    $date: String
    $station: String
    $shift: String
    $brand: String
    $withShortages: Boolean
  ) {
    listFoodComponents(
      kitchen: $kitchen
      date: $date
      station: $station
      shift: $shift
      brand: $brand
      withShortages: $withShortages
    ) {
      ...ListFoodComponentsResponseFields
    }
  }
`;

export const LIST_FOODS_BY_FILTERS_QUERY = gql`
  ${LIST_FOODS_BY_FILTERS_RESPONSE_FIELDS}
  query ListFoodsByFilters($filters: FoodFiltersInput, $page: Int, $limit: Int) {
    listFoodsByFilters(filters: $filters, page: $page, limit: $limit) {
      ...ListFoodsByFiltersResponseFields
    }
  }
`;

export const LIST_FOODS_BY_FILTERS_V2_QUERY = gql`
  ${LIST_FOODS_BY_FILTERS_RESPONSE_FIELDS}
  query ListFoodsByFiltersV2($filters: FoodFiltersInput, $page: Int, $limit: Int) {
    listFoodsByFiltersV2(filters: $filters, page: $page, limit: $limit) {
      ...ListFoodsByFiltersResponseFields
    }
  }
`;

export const LIST_FOODS_QUERY = gql`
  ${LIST_FOODS_RESPONSE_FIELDS}
  query ListFoods($kitchen: Kitchen, $date: String, $shift: String, $brand: String, $limit: Int, $next: String) {
    listFoods(kitchen: $kitchen, date: $date, shift: $shift, brand: $brand, limit: $limit, next: $next) {
      ...ListFoodsResponseFields
    }
  }
`;

export const LIST_GIFTS_QUERY = gql`
  ${LIST_GIFTS_RESPONSE_FIELDS}
  query ListGifts($query: ListGiftsReqInput) {
    listGifts(query: $query) {
      ...ListGiftsResponseFields
    }
  }
`;

export const LIST_INGREDIENTS_BY_NAME_QUERY = gql`
  ${LIST_INGREDIENTS_RESPONSE_FIELDS}
  query ListIngredientsByName($kitchen: Kitchen, $name: String) {
    listIngredientsByName(kitchen: $kitchen, name: $name) {
      ...ListIngredientsResponseFields
    }
  }
`;

export const LIST_INGREDIENTS_BY_PRECORO_CATEGORY_QUERY = gql`
  ${LIST_INGREDIENTS_RESPONSE_FIELDS}
  query ListIngredientsByPrecoroCategory($kitchen: Kitchen, $precoroCategory: [String]) {
    listIngredientsByPrecoroCategory(kitchen: $kitchen, precoroCategory: $precoroCategory) {
      ...ListIngredientsResponseFields
    }
  }
`;

export const LIST_KITCHENS_QUERY = gql`
  ${LIST_KITCHENS_RESPONSE_FIELDS}
  query ListKitchens($kitchen: Kitchen) {
    listKitchens(kitchen: $kitchen) {
      ...ListKitchensResponseFields
    }
  }
`;

export const LIST_MEAL_TIMESTAMPS_QUERY = gql`
  ${LIST_MEAL_TIMESTAMPS_RESPONSE_FIELDS}
  query ListMealTimestamps($kitchen: Kitchen!, $station: String, $date: String!, $next: String) {
    listMealTimestamps(kitchen: $kitchen, station: $station, date: $date, next: $next) {
      ...ListMealTimestampsResponseFields
    }
  }
`;

export const LIST_PRODUCTIVITY_METRICS_QUERY = gql`
  ${LIST_PRODUCTIVITY_METRICS_RESPONSE_FIELDS}
  query ListProductivityMetrics($startDate: String, $endDate: String, $kitchen: Kitchen) {
    listProductivityMetrics(startDate: $startDate, endDate: $endDate, kitchen: $kitchen) {
      ...ListProductivityMetricsResponseFields
    }
  }
`;

export const LIST_QUALITY_METRICS_QUERY = gql`
  ${LIST_QUALITY_METRICS_RESPONSE_FIELDS}
  query ListQualityMetrics($startDate: String, $endDate: String, $kitchen: Kitchen, $shift: Session) {
    listQualityMetrics(startDate: $startDate, endDate: $endDate, kitchen: $kitchen, shift: $shift) {
      ...ListQualityMetricsResponseFields
    }
  }
`;

export const LIST_STAFF_TRACKING_QUERY = gql`
  ${LIST_STAFF_TRACKING_RESPONSE_FIELDS}
  query ListStaffTracking($kitchen: Kitchen!, $startDate: String!, $endDate: String!, $shift: String) {
    listStaffTracking(kitchen: $kitchen, startDate: $startDate, endDate: $endDate, shift: $shift) {
      ...ListStaffTrackingResponseFields
    }
  }
`;

export const LIST_PROD_CONTROL_MEALS_QUERY = gql`
  ${PROD_CONTROL_MEAL_FIELDS}
  query ListProdControlMeals($kitchen: Kitchen!, $day: String!, $shift: String) {
    listProdControlMeals(kitchen: $kitchen, day: $day, shift: $shift) {
      ...ProdControlMealFields
    }
  }
`;
